module.exports = __webpack_public_path__ + "static/media/bedtimestorieslogo.e3c66e40.png";